import { initializeApp } from "firebase/app";
import { getAnalytics, setAnalyticsCollectionEnabled } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyCPE_97v4qc3rJueWhOJWml-USe41dVKmY",
  authDomain: "nitensclueservices.firebaseapp.com",
  projectId: "nitensclueservices",
  storageBucket: "nitensclueservices.appspot.com",
  messagingSenderId: "131974315039",
  appId: "1:131974315039:web:cb7f9d0e390101da9de92a",
  measurementId: "G-1JK866C7DH"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
setAnalyticsCollectionEnabled(analytics, true);

export { app, analytics };
